import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,ActionSheetController,ModalController,LoadingController } from 'ionic-angular';
import { CommonProvider } from '../../providers/common/common';
import { GenericFormValidationProvider } from '../../providers/common/form-validation';
import {FileuploadPage} from "../fileupload/fileupload"


/**
 * Generated class for the ChangeaddressesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-changeaddresses',
  templateUrl: 'changeaddresses.html',
})
export class ChangeaddressesPage {
  officetype:any="Current";
  addressObject:any;
  address1:any="";
  address2:any="";
  address3:any="";
  address4:any="";
  city:any="";
  state:any="";
  pincode:any="";
  errorDisplay:any={}
  file:any;
  constructor(private loadingCtrl:LoadingController,
    public modalCtrl: ModalController,public actionSheetCtrl: ActionSheetController,private fv:GenericFormValidationProvider, public navCtrl: NavController, public navParams: NavParams,private cp:CommonProvider) {
  }

  ionViewDidLoad() {
    ////console.log('ionViewDidLoad ChangeaddressesPage',this.navParams);
    ////console.log("flag for address",this.navParams.get("currentAdd"))
    ////console.log("flag for queryparrams",this.navParams.get("queryParams"));
    this.officetype = this.navParams.get("currentAdd")?"Current":"Office";
    this.addressObject=this.navParams.get("queryParams");
    this.address1 = this.addressObject.address1;
    this.address2 = this.addressObject.address2;
    this.address3 = this.addressObject.address3;
    this.address4 = this.addressObject.address4;
    this.city     = this.addressObject.city;
    this.state    = this.addressObject.state;
    this.pincode  = this.addressObject.pincode;

  }

   presentModal() {
            let loading = this.loadingCtrl.create({
              content: 'Please wait...'
            });
            // loading.present();
            const modal = this.modalCtrl.create(FileuploadPage,{showBackdrop: false,
                      enableBackdropDismiss: false});
            modal.onDidDismiss((fetchFileData) => {
              console.log(fetchFileData)
              if(fetchFileData){
              this.file = fetchFileData.data.split(",")[1];
              // this.file = fetchFileData.data;
              var documentData = fetchFileData.document
              let updatedData:any={};
              updatedData.ccs_addressline2=this.address2;
              updatedData.ccs_addressline3=this.address3;
              updatedData.ibhfl_stdcode=this.addressObject.stdcode;
              updatedData.ibhfl_customername=this.addressObject.customername;
              updatedData.ibhfl_role=this.addressObject.applicanttype;
              updatedData.ccs_addressline1=this.address1;
              updatedData.ccs_casecategory="CC03";
              updatedData.ibhfl_pincode=this.pincode;
              updatedData.ccs_communicationaddress=this.officetype=="Current"?true:false;
              updatedData.ccs_casedescription=" Create case for Change Address";
              updatedData.ibhfl_addresstypes=this.addressObject.addresstype;
              updatedData.ibhfl_newemailid=this.addressObject.emailid;
               
               
              updatedData.ibhfl_city=this.addressObject.cityid;
              updatedData.ccs_casetype="CT33";
              updatedData.ccs_casesubtype="ST01";
              updatedData.ibhfl_loanaccountnumber1=localStorage.getItem("cc");
              updatedData.ibhfl_state=this.addressObject.stateid;
              updatedData.ibhfl_phone2=this.addressObject.phone2;
              updatedData.ccs_remarksaddress="Create case for Change Address";
              updatedData.ibhfl_phone1=this.addressObject.phone1;
              updatedData.ibhfl_newmobileno=this.addressObject.mobile;
              updatedData.customerid=JSON.parse(localStorage.getItem("existingLoan"))[0].customercode
              updatedData.ibhfl_addressline4=this.address4;
              updatedData.ccs_originatingsource="";
              loading.present();
              this.cp.changeAddressApi(loading,updatedData,
                              this.file,
                              fetchFileData,
                              "uploaded",
                              "Document",
                              "1899f881-fdb5-ea11-a812-000d3a3e02e8",
                              "DOCAD01",fetchFileData.document).then((res:any)=>{
                                loading.dismiss();
                                 var res=JSON.parse(res)
                                 this.presentActionSheet("Your SRno. "+res.Payload.caseid+" has been resolved.")
                              })
              }
              
              
            });
                      modal.present();
                      
                    }



presentActionSheet(msg) {
    const actionSheet = this.actionSheetCtrl.create({
      title: msg,
      buttons: [
        {
          text: "OK",
          role: 'Ok',
          handler: () => {
             actionSheet.dismiss();
          }
        }
      ]
    });
    actionSheet.present();
  }
   postFormForValidation(){
    this.errorDisplay = this.fv.checkValidationFormAllControls(document.forms[0],true,[]);
     
    if(this.errorDisplay.valid){
     return false;
   }else{
   
    this.presentModal();
      
             
   }
   
   }

}



// WEBPACK FOOTER //
// ./src/pages/changeaddresses/changeaddresses.ts